import { useState, useEffect } from 'react';
import './style.common.scss';
import moment from 'moment';
import { download_csv } from 'utils/HelperFunctions';
import { getUserInfo } from 'utils/auth';
import { ReactComponent as ExpandIcon } from 'assets/icons/expand.svg';
import { ReactComponent as DownloadIcon } from 'assets/icons/download.svg';
import SearchBox from 'app/shared/SearchBox';
import { JSONSearch } from 'utils/HelperFunctions';

const eventType = {
	0: '#5ce3b5',
	1: '#fdcc55',
	'-1': '#e9445f',
};

function ChargingEvents(props) {
	const [activeTab, setActiveTab] = useState(0);
	const [openModal, setOpenModal] = useState(false);
	const [filteredData, setFilteredData] = useState(props.data.history);
	useEffect(() => {
		setFilteredData(props.data.history);
	}, [props.data]);

	useEffect(() => {
		setActiveTab(0);
	}, [props.isLive]);

	const getCSVName = () => {
		let auth = getUserInfo();
		let date = moment().format('DD-MM-YYYY_h:mmA');
		return auth.username + '_Charging_Events_' + date + '.csv';
	};

	const searchEvents = (key) => {
		let result = JSONSearch(key, props.data.history, ['vehicleno']);
		setFilteredData(result);
	};

	const JSONToCSV = () => {
		let reportData = props.data.history;
		let str = '';
		let heads = [
			{
				hdg: 'Vehicle No',
			},
			{
				hdg: 'Chraging Started At',
			},
			{
				hdg: 'Start SOC',
			},
			{
				hdg: 'Chraging Ended At',
			},
			{
				hdg: 'End SOC',
			},
		];
		let headline = '';
		for (var i = 0; i < heads.length; i++) {
			if (headline !== '') headline += ',';
			headline += heads[i]['hdg'];
		}
		str += headline + '\r\n';

		for (let idx in reportData) {
			let line = '';
			if (line !== '') line += ',';
			line += reportData[idx].vehicleno;

			str += '\r\n' + line;
			line = '';
			for (let jdx in reportData[idx].chargingevent) {
				if (line !== '') line += ',';
				line += ',';
				line +=
					moment(reportData[idx].chargingevent[jdx][0].time).format('D MMM YYYY h:mm A') +
					',' +
					reportData[idx].chargingevent[jdx][0].value +
					',' +
					moment(reportData[idx].chargingevent[jdx][1].time).format('D MMM YYYY h:mm A') +
					',' +
					reportData[idx].chargingevent[jdx][1].value;

				str += line + '\r\n';
				line = '';
			}
			// str+=line+"\r\n";
		}
		download_csv(str, getCSVName());
	};

	const renderWidgetControl = () => {
		return (
			<div
				className="WidgetControl"
				style={{ justifyContent: activeTab === 1 ? 'space-between' : 'flex-end' }}
			>
				{activeTab === 1 ? (
					<div className="SearchControl">
						<SearchBox placeholder={'Search'} rounded onSearch={searchEvents} />
					</div>
				) : null}
				<div className="WidgetTab">
					<ul>
						<li onClick={() => setActiveTab(0)} className={activeTab === 0 ? 'active' : ''}>
							Chart
						</li>
						<li onClick={() => setActiveTab(1)} className={activeTab === 1 ? 'active' : ''}>
							Table
						</li>
					</ul>
				</div>
			</div>
		);
	};

	const renderView = () => {
		return activeTab === 0 ? (
			<div className="NumStats" style={{ color: '#EB5971' }}>
				<i className="fas fa-charging-station" style={{ marginRight: 10 }}></i>
				{props.data.distribution}
			</div>
		) : (
			<div className="EventsView">
				<div className="EventsViewContainer">
					{filteredData.map((event, key) => {
						return (
							<div
								key={key}
								className="EventBox"
								style={{
									background: key % 2 === 0 ? '#F3F3F3' : 'white',
								}}
							>
								<div className="EventBoxLeft">
									<div className="EventNos">
										<span>EVENTS</span>
										<span>{event.chargingevent.length}</span>
									</div>
									<span style={{ marginLeft: '0.5rem', fontSize: 12 }}>{event.vehicleno}</span>
								</div>
								<div className="EventBoxRight">
									{event.chargingevent.map((cdevent, key) => {
										return (
											<div key={key} className="StatsChip">
												<div>
													{moment(cdevent[0].time).format('h:mm A')} -{' '}
													{moment(cdevent[1].time).format('h:mm A')}
												</div>
												<div
													style={{
														backgroundColor: eventType[cdevent[0].eventtype],
														borderColor: eventType[cdevent[0].eventtype],
														fontWeight: '600',
													}}
												>
													{cdevent[0].value} - {cdevent[1].value}
												</div>
											</div>
										);
									})}
								</div>
							</div>
						);
					})}
				</div>
			</div>
		);
	};
	return (
		<div className="WidgetContainer">
			<div className="WidgetHeader">
				<div className="Title">Charging Events</div>
				<div className="RightControl">
					<DownloadIcon onClick={JSONToCSV} style={{ marginRight: 14, cursor: 'pointer' }} />
					<ExpandIcon style={{ cursor: 'pointer' }} onClick={() => setOpenModal(true)} />
				</div>
			</div>
			<div className="WidgetContent">
				{renderWidgetControl()}
				<div className="ContentContainer">{renderView()}</div>
			</div>
			<div className="Modal" style={{ display: openModal ? 'block' : 'none' }}>
				<div className="ModalContent">
					<div className="ModalHeader">
						<span onClick={() => setOpenModal(false)} className="close">
							&times;
						</span>
					</div>
					<span
						className="mh-download"
						style={{ position: 'relative', top: '0.5rem', float: 'right' }}
					>
						<DownloadIcon onClick={JSONToCSV} style={{ marginRight: 14, cursor: 'pointer' }} />
					</span>
					<div
						className="Title"
						style={{ fontWeight: 500, position: 'relative', top: '5px', width: '500px' }}
					>
						Charging Events
					</div>
					<div className="ModalContainer">
						{renderWidgetControl()}

						<div className="WidgetView" style={{ height: '80%' }}>
							{renderView()}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default ChargingEvents;
